import { createMigration } from './utils';

/**
 * Sets isEditable to true for ColorAssets where isColorEditable is already true
 */
function setIsEditableForColorAsset(map: any, path: Array<string | number>) {
    const asset = map.getIn(path) as any;
    if (!asset) {
        return;
    }

    const classType = asset.get('classType');
    if (classType !== 'ColorAsset') {
        return;
    }

    const isColorEditable = asset.get('isColorEditable');
    if (!isColorEditable) {
        return;
    }

    map.setIn([...path, 'isEditable'], true);
}

export const migrationTo9_231 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('slides').forEach((scene: any, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            const children = map.get('children');
            if (children) {
                children.forEach((_child: any, cIndex: number) => {
                    setIsEditableForColorAsset(map, ['children', cIndex]);
                });
            }

            const subslides = map.get('subslides');
            if (!subslides) {
                return;
            }

            subslides.forEach((_subslide: any, sIndex: number) => {
                const subslide = map.getIn(['subslides', sIndex]) as any;
                if (!subslide) {
                    return;
                }

                const subslideChildren = subslide.get('children');
                if (!subslideChildren) {
                    return;
                }

                subslideChildren.forEach((_child: any, cIndex: number) => {
                    setIsEditableForColorAsset(map, ['subslides', sIndex, 'children', cIndex]);
                });
            });
        });
    },
});
